import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '../shared/shared.module';
import { DialogDataService } from './dialog-data.service';
import { DialogWrapperComponent } from './dialog-wrapper.component';
import { DialogService } from './dialog.service';

@NgModule({
    declarations: [DialogWrapperComponent],
    imports: [
        CommonModule,
        MatTooltipModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        DragDropModule,
        MatDialogModule,
        SharedModule
    ],
    exports: [DialogWrapperComponent],
    providers: [DialogDataService, DialogService]
})
export class UcrDialogModule {}
